import { ExternalLink } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface FreePlanRetentionNoticeProps {
  retentionDays?: number;
  className?: string;
}

/**
 * Tiny one-line notice that sits just below the Meetings & Notes header
 * row (title + search + actions + Add note). Free plan only.
 * Clicking "Upgrade" opens the standard credit / upgrade dialog.
 */
export default function FreePlanRetentionNotice({
  retentionDays = 90,
  className,
}: FreePlanRetentionNoticeProps) {
  return (
    <p className={cn("text-xs text-muted-foreground", className)}>
      <Trans
        i18nKey="credits.retentionNotice"
        values={{ days: retentionDays }}
        components={{
          a: <a href="/plans" className="text-accent hover:underline font-medium" />,
        }}
      />
    </p>
  );
}

/** Button that opens the full-page preview of Meetings & Notes with the
 *  Free plan retention notice in context. Opens in a new tab so it can be
 *  shared as a screenshot of the real screen. */
export function FreePlanRetentionBannerPreview() {
  const { t } = useTranslation();
  return (
    <Button variant="outline" size="sm" className="gap-1.5" asChild>
      <a href="/notes?freePlanRetention=1" target="_blank" rel="noopener noreferrer">
        <ExternalLink className="h-3.5 w-3.5" />
        {t("credits.retentionPreviewButton")}
      </a>
    </Button>
  );
}
